import { render, staticRenderFns } from "./vehiculos.vue?vue&type=template&id=c1a38154&scoped=true"
import script from "./vehiculos.vue?vue&type=script&lang=js"
export * from "./vehiculos.vue?vue&type=script&lang=js"
import style0 from "./vehiculos.vue?vue&type=style&index=0&id=c1a38154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a38154",
  null
  
)

export default component.exports